import { type FC, type ReactNode } from 'react';

import { Box, Stack } from '@eneco/sparky';

export interface BadgeIconProps {
  /** Icon element to render inside the badge, e.g. `<ProfileIcon color="iconPrimary" />`. */
  children: ReactNode;
}

/** Rounded badge container for centered Sparky icons. */
export const BadgeIcon: FC<BadgeIconProps> = ({ children }) => (
  <Box backgroundColor="backgroundTertiary" borderRadius="s" padding="3">
    <Stack alignX="center" alignY="center">
      <Stack.Item shrink={false}>{children}</Stack.Item>
    </Stack>
  </Box>
);
